export enum EditorEvent {
  /** Triggered before calling a command */
  onBeforeExecuteCommand = 'onBeforeExecuteCommand',
  /** Triggered after calling a command */
  onAfterExecuteCommand = 'onAfterExecuteCommand',
  /** Change screen state trigger */
  onGraphStateChange = 'onGraphStateChange',
  /** Change Label Status Trigger */
  onInlineEditStateChange = 'onInlineEditStateChange',
  /** Before Graph Relayout */
  onBeforeRelayout = 'onBeforeRelayout',
  /** After Graph Relayout */
  onAfterRelayout = 'onAfterRelayout',
}

export enum GraphCommonEvent {
  /** Triggered when the left mouse button is clicked or the enter key is
   * pressed */
  onClick = 'click',
  /** Triggered when the left mouse button is double-clicked */
  onDoubleClick = 'dblclick',
  /** The event is triggered when the mouse is moved into the range of the
   * element, and the event does not bubble, that is, it will not be triggered
   * when the mouse is moved to its descendant element */
  onMouseEnter = 'mouseenter',
  /** The mouse is constantly triggered when it moves inside the element, and
   * cannot be triggered by the keyboard */
  onMouseMove = 'mousemove',
  /** Triggered after the mouse moves out of the target element */
  onMouseOut = 'mouseout',
  /** Move the mouse over the target element, and it will be triggered when the
   * mouse moves over its descendant element */
  onMouseOver = 'mouseover',
  /** Triggered when the mouse moves out of the element range, the event does
   * not bubble, that is, it will not be triggered when the mouse moves to its
   * descendant element */
  onMouseLeave = 'mouseleave',
  /** Triggered when the mouse button is pressed (left or right), it cannot be
   * triggered by keyboard */
  onMouseDown = 'mousedown',
  /** Triggered when the mouse button is released, it cannot be triggered by the
   * keyboard */
  onMouseUp = 'mouseup',
  /** Triggered when the user right-clicks the mouse and opens the context menu */
  onContextMenu = 'contextmenu',
  /** Event triggered when the dragged element starts to be dragged, this event
   * acts on the dragged element */
  onDragStart = 'dragstart',
  /** Event triggered when the dragged element is in the drag process, this
   * event acts on the dragged element */
  onDrag = 'drag',
  /** This event is on the drag element when dragging the event. */
  onDragEnd = 'dragend',
  /** When the drag element enters the target element, this event acts on the
   * target element.  */
  onDragEnter = 'dragenter',
  /** This event acts on the target element when the drag elements leave the
   * target element.  */
  onDragLeave = 'dragleave',
  /** The dragged element is disconnected on the target element, and this event
   * is active on the target element.  */
  onDrop = 'drop',
  /** Press the keyboard button to trigger the event */
  onKeyDown = 'keydown',
  /** Release the keyboard button to trigger the event */
  onKeyUp = 'keyup',
  /** When the finger touchs the screen, it is triggered even if there is
   * already a finger on the screen.  */
  onTouchStart = 'touchstart',
  /** Continuously trigger when the finger slides on the screen. During this
   * event, calling `preventdefault()` events can block scrolling.  */
  onTouchMove = 'touchmove',
  /** When the finger is triggered from the screen */
  onTouchEnd = 'touchend',
  /** When the wheel on changes to zoom */
  onWheelZoom = 'wheelzoom',
  /** When the wheel of the mouse changes */
  onWheel = 'wheel',
  /** When there has been any change in the viewport (EG: zoom, pan) */
  onViewportChange = 'viewportchange',
  /** Triggered before the mode (EG: default, readonly, overlayvisible) changes */
  onBeforeModeChange = 'beforemodechange',
  /** Triggered after the mode (EG: default, readonly, overlayvisible) changes */
  onAfterModeChange = 'aftermodechange',
}

export enum GraphNodeEvent {
  /** Trigger when the left button is clicked */
  onNodeClick = 'node:click',
  /** Mouse double-click the left button node to trigger */
  onNodeDoubleClick = 'node:dblclick',
  /** Trigger when the mouse is moved into the node */
  onNodeMouseEnter = 'node:mouseenter',
  /** The mouse is constantly triggered when the mouse is moved to the node, and
   * cannot trigger by the keyboard. */
  onNodeMouseMove = 'node:mousemove',
  /** Triggered after the mouse moves out of the node */
  onNodeMouseOut = 'node:mouseout',
  /** Triggered when the mouse moves over the node */
  onNodeMouseOver = 'node:mouseover',
  /** Triggered when the mouse moves out of the node */
  onNodeMouseLeave = 'node:mouseleave',
  /** Triggered when the mouse button is pressed (left or right) on the node, it
   * cannot be triggered by the keyboard */
  onNodeMouseDown = 'node:mousedown',
  /** Triggered when the mouse button pressed on the node is released and popped
   * up, it cannot be triggered by the keyboard */
  onNodeMouseUp = 'node:mouseup',
  /** Users trigger and open the right-click menu on the node. */
  onNodeContextMenu = 'node:contextmenu',
  /** When the node is triggered when the node is dragged, this event is on the
   * drag node */
  onNodeDragStart = 'node:dragstart',
  /** This event acts on the drag node when the node is triggered during the
   * drag process. */
  onNodeDrag = 'node:drag',
  /** When the event triggered after the drag is completed, this event is on the
   * drag node  */
  onNodeDragEnd = 'node:dragend',
  /** When the drag node is triggered when the target element is turned, this
   * event is on the target element  */
  onNodeDragEnter = 'node:dragenter',
  /** When the drag node is triggered when leaving the target element, this
   * event acts on the target element  */
  onNodeDragLeave = 'node:dragleave',
  /** Dragd node is on the target element to disconnect the triggered event,
   * this event is on the target element  */
  onNodeDrop = 'node:drop',
}

export enum GraphEdgeEvent {
  /** Trigger when the left button hit the side */
  onEdgeClick = 'edge:click',
  /** Trigger when the mouse doubles the left button */
  onEdgeDoubleClick = 'edge:dblclick',
  /** Trigger when mouse moves */
  onEdgeMouseEnter = 'edge:mouseenter',
  /** The mouse is turned up to the edge to constantly trigger, and cannot
   * trigger by the keyboard.  */
  onEdgeMouseMove = 'edge:mousemove',
  /** The mouse is moved after the side is triggered. */
  onEdgeMouseOut = 'edge:mouseout',
  /** Trigger when the mouse is moved above */
  onEdgeMouseOver = 'edge:mouseover',
  /** The mouse is moved while triggering */
  onEdgeMouseLeave = 'edge:mouseleave',
  /** The mouse button is triggered while pressing (left button or right) while
   * it cannot be triggered by the keyboard.  */
  onEdgeMouseDown = 'edge:mousedown',
  /** The mouse button pressed on the side is triggered when the mouse button is
   * released, and cannot be triggered by the keyboard.  */
  onEdgeMouseUp = 'edge:mouseup',
  /** The user triggers and opens the right-click menu when right mouse on the
   * side.  */
  onEdgeContextMenu = 'edge:contextmenu',
}

export enum GraphCanvasEvent {
  /** Trigger when the mouse is left button */
  onCanvasClick = 'canvas:click',
  /** The mouse double-click left miles to trigger */
  onCanvasDoubleClick = 'canvas:dblclick',
  /** The mouse is moved to the canvas */
  onCanvasMouseEnter = 'canvas:mouseenter',
  /** The mouse is constantly triggering during the canvas, and cannot trigger
   * by the keyboard.  */
  onCanvasMouseMove = 'canvas:mousemove',
  /** The mouse is removed from the canvas */
  onCanvasMouseOut = 'canvas:mouseout',
  /** Trigger when the mouse is moved above the canvas */
  onCanvasMouseOver = 'canvas:mouseover',
  /** When the mouse is removed from the canvas */
  onCanvasMouseLeave = 'canvas:mouseleave',
  /** The mouse button is triggered when pressing (left button or right) on the
   * canvas, can't trigger by the keyboard  */
  onCanvasMouseDown = 'canvas:mousedown',
  /** The mouse button pressed on the canvas is triggered when the mouse is
   * released, and cannot trigger by the keyboard.  */
  onCanvasMouseUp = 'canvas:mouseup',
  /** Users trigger and open the right-click menu when you right on the mouse on
   * the canvas.  */
  onCanvasContextMenu = 'canvas:contextmenu',
  /** When the canvas starts to trigger, this event is on the drag canvas. */
  onCanvasDragStart = 'canvas:dragstart',
  /** This event acts on the drag canvas when the event is triggered during the
   * drag process.  */
  onCanvasDrag = 'canvas:drag',
  /** This event is on the drag canvas when the event is triggered after the
   * drag is completed.  */
  onCanvasDragEnd = 'canvas:dragend',
  /** This event effects on the target element when dragging the visualization
   * into the target element.  */
  onCanvasDragEnter = 'canvas:dragenter',
  /** This event acts on the target element when dragging the visual exiting the
   * target element.  */
  onCanvasDragLeave = 'canvas:dragleave',
}

export enum GraphCustomEvent {
  /** Trigger before calling the add / additem method */
  onBeforeAddItem = 'beforeadditem',
  /** Trigger after calling the add / additem method */
  onAfterAddItem = 'afteradditem',
  /** Trigger before calling the remove / removeItem method */
  onBeforeRemoveItem = 'beforeremoveitem',
  /** Trigger after calling the remove / removeItem method */
  onAfterRemoveItem = 'afterremoveitem',
  /** Trigger before calling the update / updateItem method */
  onBeforeUpdateItem = 'beforeupdateitem',
  /** Trigger after calling the update / updateItem method */
  onAfterUpdateItem = 'afterupdateitem',
  /** Trigger before calling the showItem / hideItem method */
  onBeforeItemVisibilityChange = 'beforeitemvisibilitychange',
  /** Trigger after calling the showItem / hideItem method */
  onAfterItemVisibilityChange = 'afteritemvisibilitychange',
  /** Trigger before calling the setItemState method */
  onBeforeItemStateChange = 'beforeitemstatechange',
  /** Trigger after calling the setItemState method */
  onAfterItemStateChange = 'afteritemstatechange',
  /** Trigger before calling the refreshitem method */
  onBeforeRefreshItem = 'beforerefreshitem',
  /** Trigger after calling the refreshitem method */
  onAfterRefreshItem = 'afterrefreshitem',
  /** Trigger before calling the clearItemStates method */
  onBeforeItemStatesClear = 'beforeitemstatesclear',
  /** Trigger after calling the clearItemStates method */
  onAfterItemStatesClear = 'afteritemstatesclear',
  /** Trigger before the layout. The layout will be made when calling render, so
   * render is triggered. Or when the user actively calls Layout when the map is
   * called.  */
  onBeforeLayout = 'beforelayout',
  /** Trigger after the layout is completed. Will layout when calling render, so
   * render is triggered after the layout is complete. Or when the user actively
   * called the layout of the map, the layout is triggered.  */
  onAfterLayout = 'afterlayout',
  /** Trigger after the connection is completed */
  onAfterConnect = 'afterconnect',
}

/** Events emitted on individual shapes */
export enum ShapeEvent {
  /** Tooltip destroyed */
  onTooltipDestroy = 'shape:tooltipdestroy',
}

export enum ViewportChangeAction {
  Move = 'move',
  Translate = 'translate',
  Zoom = 'zoom',
}

export type FlowchartEvent =
  | EditorEvent
  | GraphCommonEvent
  | GraphNodeEvent
  | GraphEdgeEvent
  | GraphCanvasEvent
  | GraphCustomEvent;

export const FlowchartEvent = {
  ...EditorEvent,
  ...GraphCommonEvent,
  ...GraphNodeEvent,
  ...GraphEdgeEvent,
  ...GraphCanvasEvent,
  ...GraphCustomEvent,
};
